import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as forgotPasscodeState from '../reducers/forgot-passcode.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region FORGOT PASSCODE USER NEEDS HELP STATE
export const getForgotPasscodeState = createSelector(
  getAuthState,
  state => state[forgotPasscodeState.forgotPasswordUserNeedsHelpFeatureKey]
);

export const getForgotPasscodeUserNeedsHelpIsLoading = createSelector(
  getForgotPasscodeState,
  forgotPasscodeState.getForgotPasswordsUserNeedsHelpIsLoading
);

export const getForgotPasscodeUserNeedsHelpRequest = createSelector(
  getForgotPasscodeState,
  forgotPasscodeState.getForgotPasswordsUserNeedsHelpRequest
);

export const getForgotPasscodeUserNeedsHelpResponse = createSelector(
  getForgotPasscodeState,
  forgotPasscodeState.getForgotPasswordsUserNeedsHelpResponse
);

export const getForgotPasscodeUserNeedsHelpFailure = createSelector(
  getForgotPasscodeState,
  forgotPasscodeState.getForgotPasswordsUserNeedsHelpFailure
);
//#endregion
